/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  canvasGrid: Item<'CanvasGrid'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  numberValueNumberColumn: Item<'NumberColumn'>;
  root: Item<'Page'>;
  starColumn: Item<'StarColumn'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  idNumberColumn: Item<'NumberColumn'>;
} = {
  canvasGrid: {
    children: ['idNumberColumn', 'starColumn', 'numberValueNumberColumn'],
    itemId: 'canvasGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      expandLastColumn: false,
      showBorder: false,
      updatable: {
        type: 'boolean',
        value: true,
      },
    },
    type: 'CanvasGrid',
  },
  flexItem: {
    children: ['testAliasDataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'canvasGrid',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'ID' },
      viewAttribute: 'id',
      width: 62,
    },
    type: 'NumberColumn',
  },
  numberValueNumberColumn: {
    children: [],
    itemId: 'numberValueNumberColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      allowDecimal: false,
      label: { type: 'text', value: 'Number Value' },
      viewAttribute: 'value',
      width: 127,
    },
    type: 'NumberColumn',
  },
  root: {
    children: ['testAliasLocalDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: {
        all: 0,
      },
      windowTitle: {
        type: 'text',
        value: 'Star Column',
      },
    },
    type: 'Page',
  },
  starColumn: {
    children: [],
    itemId: 'starColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      color: 'warning',
      label: { type: 'text', value: 'Star Column' },
      updatable: {
        type: 'expression',
        value: '$.testAlias.id % 2 === 0',
      },
      viewAttribute: 'value',
      width: 300,
    },
    type: 'StarColumn',
  },
  testAliasDataStoreReference: {
    children: ['canvasGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'flexItem',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData:
        '[\n    {\n        "value": 3\n    },\n    {\n        "value": 1\n    },\n    {\n        "value": 0\n    },\n    {\n        "value": 5\n    },\n    {\n        "value": 4\n    }\n]',
    },
    type: 'LocalDataStore',
  },
};

export const helpRenders: ComponentSample<'StarColumn'>[] = [
  {
    title: 'Rating Column',
    page,
    exampleId: 'eg-01GK8QWM9KTAE6TN0ME1F8WQKG',
    clearParentChildren: false,
    height: 380,
    visibleProps: ['alignment', 'color', 'updatable', 'numberOfStars'],
    item: {
      children: [],
      itemId: 'starColumn',
      parent: 'canvasGrid',
      props: {
        alignment: 'center',
        color: 'warning',
        label: { type: 'text', value: 'Star Column' },
        updatable: {
          type: 'expression',
          value: '$.testAlias.id % 2 === 0',
        },
        viewAttribute: 'value',
        width: 300,
      },
      type: 'StarColumn',
    },
  },
];
